import { TrackSchemaWithUsage } from '../../../modules/page/checkout/model';

const cLineSymbol = '\u00A9';
const pLineSymbol = '\u2117';

export const cline = (track: TrackSchemaWithUsage): string => {
  const release = track.releases[0];

  if (release && release.c_line !== null && release.c_line !== '') {
    return release.c_line.replace(cLineSymbol, '');
  }

  return parseInt(track.available_at) + ' ' + track.rightsholders[0].name;
};

export const pline = (track: TrackSchemaWithUsage): string => {
  if (track && track.p_line !== null && track.p_line !== '') {
    return track.p_line.replace(pLineSymbol, '');
  }

  return parseInt(track.available_at) + ' ' + track.rightsholders[0].name;
};

export const combinedPCLine = (track: TrackSchemaWithUsage): string => {
  const c_line = cline(track);
  const p_line = pline(track);

  if (p_line === c_line) {
    return `${cLineSymbol} ${pLineSymbol} ${c_line}`;
  }

  return `${cLineSymbol} ${c_line}\n${pLineSymbol} ${p_line}`;
};
